/**
 * Day / Month / Year selects that sync to a hidden ISO date input (YYYY-MM-DD).
 * Markup: wrap with [data-date-parts] containing [name] hidden input +
 * [data-date-day], [data-date-month], [data-date-year] selects.
 */
window.WinwinDateParts = (function () {
  var MONTHS = [
    { v: '01', l: '01' },
    { v: '02', l: '02' },
    { v: '03', l: '03' },
    { v: '04', l: '04' },
    { v: '05', l: '05' },
    { v: '06', l: '06' },
    { v: '07', l: '07' },
    { v: '08', l: '08' },
    { v: '09', l: '09' },
    { v: '10', l: '10' },
    { v: '11', l: '11' },
    { v: '12', l: '12' }
  ];

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function daysInMonth(year, month) {
    if (!year || !month) return 31;
    return new Date(year, month, 0).getDate();
  }

  function fillSelect(select, options, placeholder) {
    if (!select) return;
    var html = '<option value="">' + placeholder + '</option>';
    options.forEach(function (opt) {
      html += '<option value="' + opt.v + '">' + opt.l + '</option>';
    });
    select.innerHTML = html;
  }

  function yearOptions(minYear, maxYear) {
    var out = [];
    for (var y = maxYear; y >= minYear; y--) {
      out.push({ v: String(y), l: String(y) });
    }
    return out;
  }

  function dayOptions(count) {
    var out = [];
    for (var d = 1; d <= count; d++) {
      out.push({ v: pad(d), l: pad(d) });
    }
    return out;
  }

  function syncHidden(root) {
    var hidden = root.querySelector('input[type="hidden"][name]');
    var day = root.querySelector('[data-date-day]');
    var month = root.querySelector('[data-date-month]');
    var year = root.querySelector('[data-date-year]');
    if (!hidden || !day || !month || !year) return;
    if (day.value && month.value && year.value) {
      hidden.value = year.value + '-' + month.value + '-' + day.value;
    } else {
      hidden.value = '';
    }
    hidden.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refreshDays(root) {
    var day = root.querySelector('[data-date-day]');
    var month = root.querySelector('[data-date-month]');
    var year = root.querySelector('[data-date-year]');
    if (!day || !month || !year) return;
    var prev = day.value;
    var count = daysInMonth(parseInt(year.value, 10) || 0, parseInt(month.value, 10) || 0);
    fillSelect(day, dayOptions(count), 'DD');
    if (prev && parseInt(prev, 10) <= count) {
      day.value = prev;
    }
  }

  function enhance(root) {
    if (!root || root.dataset.datePartsReady === '1') return;
    root.dataset.datePartsReady = '1';

    var day = root.querySelector('[data-date-day]');
    var month = root.querySelector('[data-date-month]');
    var year = root.querySelector('[data-date-year]');
    var hidden = root.querySelector('input[type="hidden"][name]');
    if (!day || !month || !year || !hidden) return;

    var now = new Date();
    var minYear = parseInt(root.getAttribute('data-min-year') || '1920', 10);
    var maxYearAttr = root.getAttribute('data-max-year') || 'now';
    var maxYear = maxYearAttr === 'now' ? now.getFullYear() : parseInt(maxYearAttr, 10);
    if (!maxYear || maxYear < minYear) maxYear = now.getFullYear();

    fillSelect(month, MONTHS.map(function (m) { return { v: m.v, l: m.l }; }), 'MM');
    fillSelect(year, yearOptions(minYear, maxYear), 'YYYY');
    fillSelect(day, dayOptions(31), 'DD');

    // Restore from existing hidden value (e.g. validation redisplay)
    if (hidden.value && /^\d{4}-\d{2}-\d{2}$/.test(hidden.value)) {
      var parts = hidden.value.split('-');
      year.value = parts[0];
      month.value = parts[1];
      refreshDays(root);
      day.value = parts[2];
    }

    function onChange() {
      refreshDays(root);
      syncHidden(root);
    }

    day.addEventListener('change', onChange);
    month.addEventListener('change', onChange);
    year.addEventListener('change', onChange);
  }

  function bind(scope) {
    (scope || document).querySelectorAll('[data-date-parts]').forEach(enhance);
  }

  return { bind: bind, enhance: enhance };
})();
